export default __webpack_public_path__ + "static/media/cp_geo_ss.8b2f0948.svg";